import { render, staticRenderFns } from "./audit-log.vue?vue&type=template&id=14b20f73&scoped=true&"
import script from "./audit-log.vue?vue&type=script&lang=js&"
export * from "./audit-log.vue?vue&type=script&lang=js&"
import style0 from "./audit-log.vue?vue&type=style&index=0&id=14b20f73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b20f73",
  null
  
)

export default component.exports